import styled from 'styled-components';

export const PaymentDetailsHeading = styled.span`
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  color: #1e293b;
  margin-bottom: 18px;
`;

export const PaymentBankDetailHeading = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
  margin-bottom: 6px;
`;

export const PaymentBankDetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const PaymentBankDetails = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: #64748b;
`;

export const BankPaymentDetailsDisclaimerContainer = styled.div`
  border: 1px solid #d97706;
  background-color: #fffbeb;
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 16px;
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const DisclaimerContainerHeading = styled.span`
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: #d97706;
  margin-bottom: 2px;
`;

export const DisclaimerContainerDescription = styled.span`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
  color: #475569;
`;

export const CopyTextIconBox = styled.div`
  cursor: pointer;
`;

export const DownloadIconBox = styled.div`
  margin-right: 6px;
`;
